//  document.addEventListener("DOMContentLoaded", function () {
//   const words = document.querySelectorAll('.text-rotator .rotator-word');
//   let index = 0;

//   function rotateText() {
//     if(words.length > 0)
//     {
//       words[index].classList.remove('is-visible');
//       words[index].classList.add('is-hidden');

//       index = (index + 1) % words.length;

//       words[index].classList.remove('is-hidden');
//       words[index].classList.add('is-visible');
//     }
//   }

//   setInterval(rotateText, 2000);
// });


// document.addEventListener('DOMContentLoaded', function () {

//   function updateCartAttributes() {
//     const data = {
//       attributes: {
//         'Vehicle Registration': document.getElementById('registration')?.value || '',
//         'Make': document.getElementById('make')?.value || '',
//         'Model': document.getElementById('model')?.value || '',
//         'Year': document.getElementById('year')?.value || '',
//         'VN Number': document.getElementById('vn')?.value || '',
//         'Image1': document.getElementById('u1')?.value || '',
//         'Image2': document.getElementById('u2')?.value || '',
//         'Image3': document.getElementById('u3')?.value || ''
//       }
//     };

//     fetch('/cart/update.js', {
//       method: 'POST',
//       headers: {
//         'Content-Type': 'application/json'
//       },
//       body: JSON.stringify(data)
//     })
//     .then(response => response.json())
//     .then(() => {

//       console.log('Vehicle data saved in cart attributes', data);
//     })
//     .catch(error => {
//       console.error('Cart attribute update failed', error);
//     });
//   }

//   const fields = ['registration', 'make', 'model', 'year', 'vn', 'u1', 'u2', 'u3'];

//   fields.forEach(function (id) {
//     const input = document.getElementById(id);
//     if (!input) return;

//     input.addEventListener('change', updateCartAttributes);
//     input.addEventListener('blur', updateCartAttributes);
//   });

// });


document.addEventListener("DOMContentLoaded", function () {
  const words = document.querySelectorAll('.text-rotator .rotator-word');
  const images = document.querySelectorAll('.hero-image .rotator-image');
  let index = 0;

  function rotateContent() {
    if (words.length === 0 || images.length === 0) return;

    // Hide current
    words[index].classList.remove('is-visible');
    words[index].classList.add('is-hidden');

    images[index].classList.remove('is-visible');
    images[index].classList.add('is-hidden');

    // Next index
    index = (index + 1) % words.length;

    // images[index].style.top = '-50px';  
    // images[index].style.opacity = '0';

    // Show next
    words[index].classList.remove('is-hidden');
    words[index].classList.add('is-visible');

    images[index].classList.remove('is-hidden');
    images[index].classList.add('is-visible');

    // images[index].style.top = '10px';
    // images[index].style.opacity = '0';
  }

  setInterval(rotateContent, 2000);
});



// // Aspire Logics Code Start from Below

// document.addEventListener("DOMContentLoaded", function(){


// let jsonData = [];

// let currentStep = 1;


// let userData = {

//     Make:"",
//     Model:"",
//     Badge:""

// };



// // JSON URL

// const jsonURL = 
// "https://demoaspire.com/canterbury-seat-cover/canterbury_json/canterbury_seat_cover.json";




// // Load JSON

// fetch(jsonURL)

// .then(response => response.json())

// .then(data => {


//     jsonData = data;


//     console.log(
//         "JSON Loaded",
//         jsonData
//     );


// })

// .catch(error=>{


//     console.log(
//         "JSON Loading Error",
//         error
//     );


// });




// // Open popup

// document
// .getElementById("find_matching")
// .addEventListener("click",function(e){


//     e.preventDefault();


//     document
//     .getElementById("matching_popup")
//     .style.display="block";


//     currentStep = 1;


//     showStep();


// });





// // Close popup

// document
// .getElementById("matching_close")
// .addEventListener("click",function(){


// document
// .getElementById("matching_popup")
// .style.display="none";


// });






// function showStep(){



// let content =
// document.getElementById("matching_content");




// if(currentStep===1){


// content.innerHTML = `

// <h2>
// Enter Make
// </h2>


// <input 
// type="text"
// id="make_input"
// placeholder="Example: Toyota"
// autofocus>


// `;



// focusInput("make_input");



// }





// if(currentStep===2){


// content.innerHTML = `


// <h2>
// Enter Model
// </h2>


// <input 
// type="text"
// id="model_input"
// placeholder="Example: Hilux"
// autofocus>


// `;


// focusInput("model_input");



// }





// if(currentStep===3){


// content.innerHTML = `


// <h2>
// Enter Badge
// </h2>


// <input 
// type="text"
// id="badge_input"
// placeholder="Example: SR5"
// autofocus>


// `;


// focusInput("badge_input");


// }





// }





// function focusInput(id){


// let input =
// document.getElementById(id);



// input.addEventListener(
// "keypress",
// function(e){


// if(e.key==="Enter"){



// saveStep(
// id,
// input.value
// );



// }


// });


// }






// function saveStep(id,value){


// value=value.trim();



// if(value===""){
// return;
// }



// if(id==="make_input"){


// userData.Make=value;

// currentStep=2;


// }



// if(id==="model_input"){


// userData.Model=value;

// currentStep=3;


// }



// if(id==="badge_input"){


// userData.Badge=value;


// searchProduct();


// return;

// }




// showStep();


// }






// function searchProduct(){



// let result =
// jsonData.filter(item =>


// item.Make.toLowerCase()
// ===
// userData.Make.toLowerCase()



// &&



// item.Model.toLowerCase()
// ===
// userData.Model.toLowerCase()



// &&



// item.Badge.toLowerCase()
// ===
// userData.Badge.toLowerCase()



// );






// let content =
// document.getElementById("matching_content");





// if(result.length===0){



// content.innerHTML=`

// <h2>
// No Matching Found
// </h2>


// <p>
// Please check your details.
// </p>

// `;

// return;


// }







// content.innerHTML=`

// <h2>
// Matching Found
// </h2>


// ${result.map(item=>`


// <div class="matching-result">


// <h3>
// ${item.Make} ${item.Model}
// </h3>


// <p>
// Badge: ${item.Badge}
// </p>


// <p>
// Year:
// ${item["Year From"]}
// -
// ${item["Year To"]}
// </p>



// <h4>
// Available Products
// </h4>


// <ul class="matching-products">


// ${item.Products.map(product=>`

// <li>
// ${product}
// </li>

// `).join("")}


// </ul>



// </div>



// `).join("")}



// `;




// }




// });

// // Aspire Logics Code ends here 